import type { HTMLAttributes } from 'react'
import React from 'react'

interface IconsProps extends HTMLAttributes<HTMLDivElement> {}

const XlsxIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="-3 -3 24 24" //custom viewPort cho nó center :)
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM8 12H2V16H8V12ZM10 12V16H16V12H10ZM8 10V6H2V10H8ZM10 10H16V6H10V10ZM2 4H16V2H2V4Z"
                    fill="#589C5B"
                />
            </svg>
        </div>
    )
}

export default XlsxIcons
